import { post, get } from './http.api';
import {
  Parameters,
  CategoryTableRow,
  CategoryTableData,
  CategoryResponse,
  CategoryApiData,
} from '@app/models/product_categories/CategoryResponse';
import { CategoryRequest } from '@app/models/product_categories/CategoryRequest';

export const getCategoryTableData = async (parameters: Parameters): Promise<CategoryTableData> => {
  try {
    const { data, status } = await get<any>('product_categories', { params: parameters }, true);
    console.log(`Status: ${status}`, `Data:`, data);

    const categories: CategoryTableRow[] = data.data.map((categoryData: any) => ({
      id: categoryData.id,
      code: categoryData.code,
      name: categoryData.name,
    }));

    return {
      data: categories,
      pagination: {
        current: data.current_page,
        pageSize: data.per_page,
        total: data.total,
      },
      status_options: data.status_options,
    };
  } catch (error: any) {
    console.error('Error fetching categories:', error);
    throw error;
  }
};

export const getAllCategories = async (): Promise<CategoryResponse> => {
  try {
    const { data, status } = await get<CategoryResponse>(`product_categories`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getCategoryById = async (id: number): Promise<CategoryResponse> => {
  try {
    const { data, status } = await get<CategoryResponse>(`product_categories/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const storeCategory = async (categoryData: CategoryRequest) => {
  try {
    const response = await post<any>('product_categories/create', categoryData, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const createCategory = async (): Promise<CategoryApiData> => {
  try {
    const { data, status } = await get<CategoryApiData>(`product_categories/create`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const showCategory = async (id: number) => {
  try {
    const { data, status } = await get<CategoryApiData>(`product_categories/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const editCategory = async (id: number) => {
  try {
    const { data, status } = await get<CategoryApiData>(`product_categories/${id}/edit`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const updateCategory = async (id: number, Updatecategory: CategoryRequest) => {
  try {
    const { data, status } = await post<CategoryRequest>(
      `product_categories/${id}/edit`,
      Updatecategory,
      undefined,
      true,
    );
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};
